import BrandFreeAreaService from '@/services/free-area/brand-free-area'

export default class ReviewCompleteFreeAreaService extends BrandFreeAreaService {
  protected get freeAreaPaths() {
    return [
      'ReviewPostCompleteFreeArea',
    ]
  }
}
